export const CHAT_ONLY_SEARCH_RECORD_TYPES = new Set([
    "user_profile",
    "conversation",
    "topic",
]);

export const CHAT_ONLY_CONVERSATION_TYPES = new Set([
    "group",
    "group-one-off",
    "dm",
    "topic",
]);

export function shouldDismissLocateForSearchRecordType(recordType) {
    return CHAT_ONLY_SEARCH_RECORD_TYPES.has(recordType);
}

export function shouldDismissLocateForConversationType(
    conversationType,
    entityNavigateWithLocator,
) {
    if (entityNavigateWithLocator) {
        return false;
    }

    return CHAT_ONLY_CONVERSATION_TYPES.has(conversationType);
}

export function getActiveLocateHighlightDismissalState() {
    return {
        active_item_locator_cancel: true,
        active_item_locator: null,
        active_item_locator_temp: null,
        active_item_locator_type: null,
        show_work_rail_locator: false,
    };
}

export function getActiveLocateHighlightArmedState(type, locatorTemp) {
    return {
        active_item_locator_cancel: false,
        active_item_locator: null,
        active_item_locator_type: type,
        active_item_locator_temp: locatorTemp,
        show_work_rail_locator: false,
    };
}

/**
 * True when the entity locator CSS class is present in the DOM.
 * Missing activators make Vuetify park the tooltip at top-left (near AppBar).
 *
 * @param {unknown} locator_class
 * @param {ParentNode | null} [root]
 * @returns {boolean}
 */
export function isEntityLocatorTargetInDom(
    locator_class,
    root = typeof document !== "undefined" ? document : null,
) {
    if (
        !root ||
        typeof locator_class !== "string" ||
        locator_class.length === 0
    ) {
        return false;
    }

    return Boolean(root.querySelector(`.${locator_class}`));
}

/**
 * Whether a locate retry/give-up may clear armed highlight state.
 * Requires a real armed class from attempt start. `null === null` must NOT
 * clear — a newer locate that already promoted also has temp null but keeps
 * `show_work_rail_locator` on; an unarmed stale retry must not hide that pin.
 *
 * @param {string|null|undefined} current_temp
 * @param {string|null|undefined} expected_locator_class
 * @returns {boolean}
 */
export function shouldClearArmedLocateTemp(
    current_temp,
    expected_locator_class,
) {
    if (
        typeof expected_locator_class !== "string" ||
        expected_locator_class.length === 0
    ) {
        return false;
    }

    return current_temp === expected_locator_class;
}
